var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessScreeningMobileNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32812 5.72435V4.01923C6.32812 3.54837 6.72687 3.16666 7.21875 3.16666H10.3359C10.8278 3.16666 11.2266 3.54837 11.2266 4.01923V5.72435M3.65625 14.25H14.3438C15.3275 14.25 16.125 13.4866 16.125 12.5449V7.42948C16.125 6.48777 15.3275 5.72435 14.3438 5.72435H3.65625C2.67249 5.72435 1.875 6.48777 1.875 7.42948V12.5449C1.875 13.4866 2.67249 14.25 3.65625 14.25Z",
    stroke: "#080917",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessScreeningMobileNav);
export default __webpack_public_path__ + "static/media/business-screening-mobile-nav.04e7f13ac7b281445a717420500b27d4.svg";
export { ForwardRef as ReactComponent };